import { CmsApplianceDetailsSteppedMultiPlanForm } from './cms-appliance-details-stepped-multi-plan-form.interface';

export interface ApplianceDetailsSteppedMultiPlanFormConfig {
  applianceMaximumAge: Date;
  cmsData: CmsApplianceDetailsSteppedMultiPlanForm;
}
